import { useNavigate, useMatch } from 'react-router';
import { useLocalizedPath } from './useLocalizedPath';
import { isMigratedPath } from '../../../config/migrated_routes';

export const useLocalizedNavigate = () => {
  const history = useNavigate();
  const match = useMatch('/:lang?/*');
  const generatePath = useLocalizedPath();

  return (pathKey, { params, options } = {}) => {
    if (pathKey === 0) {
      history(0);
      return;
    }

    const path = generatePath(match.params.lang, pathKey, params);
    const search = params?.search;

    // Pages owned by the Next.js app are not part of the SPA route table, so a client-side
    // transition would render the catch-all redirect instead of the requested page.
    if (isMigratedPath(path)) {
      const target = search ? `${ path }${ search.startsWith('?') ? '' : '?' }${ search }` : path;

      if (options?.replace) {
        window.location.replace(target);
      } else {
        window.location.assign(target);
      }
      return;
    }

    history({ pathname: path, search }, options);
  };
};
